import type React from 'react';

// Shopping bag icon path extracted from Shopping.svg
export const SHOPPING_ICON_PATH = `<path fill-rule="evenodd" clip-rule="evenodd" d="M9.00024 3.5V3C9.00024 2.17157 9.67182 1.5 10.5002 1.5H11.5002C12.3287 1.5 13.0002 2.17157 13.0002 3V3.5H14.477C14.762 3.5 14.9894 3.73794 14.9764 4.0227L14.7502 9L14.967 12.4688C14.985 12.7567 14.7564 13 14.468 13H9.43131L9.25274 10.5L9.45939 7.60687C9.52141 6.73857 8.83371 6 7.9632 6H7.11384L7.02396 4.0227C7.01102 3.73794 7.23839 3.5 7.52345 3.5H9.00024ZM10.0002 3C10.0002 2.72386 10.2241 2.5 10.5002 2.5H11.5002C11.7764 2.5 12.0002 2.72386 12.0002 3V3.5H10.0002V3Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.25528 10.5712L8.46189 13.4644C8.48256 13.7538 8.25333 14 7.96316 14H1.53714C1.24696 14 1.01773 13.7538 1.03841 13.4644L1.24506 10.5712C1.24845 10.5238 1.24845 10.4762 1.24506 10.4288L1.03841 7.53562C1.01773 7.24619 1.24696 7 1.53714 7H3.00024V6.5C3.00024 5.67157 3.67182 5 4.50024 5H5.00024C5.82867 5 6.50024 5.67157 6.50024 6.5V7H7.96316C8.25333 7 8.4826 7.24619 8.46193 7.53562L8.25528 10.4288C8.25189 10.4762 8.25189 10.5238 8.25528 10.5712ZM5.50024 7V6.5C5.50024 6.22386 5.27639 6 5.00024 6H4.50024C4.2241 6 4.00024 6.22386 4.00024 6.5V7H5.50024Z" fill="white"/>`;

export type ShoppingIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

/**
 * Shopping bag icon for POI markers
 *
 * Designed for 16x16px display within 24x24px circular backgrounds
 */
export const ShoppingIcon: React.FC<ShoppingIconProps> = ({ size = 16, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00024 3.5V3C9.00024 2.17157 9.67182 1.5 10.5002 1.5H11.5002C12.3287 1.5 13.0002 2.17157 13.0002 3V3.5H14.477C14.762 3.5 14.9894 3.73794 14.9764 4.0227L14.7502 9L14.967 12.4688C14.985 12.7567 14.7564 13 14.468 13H9.43131L9.25274 10.5L9.45939 7.60687C9.52141 6.73857 8.83371 6 7.9632 6H7.11384L7.02396 4.0227C7.01102 3.73794 7.23839 3.5 7.52345 3.5H9.00024ZM10.0002 3C10.0002 2.72386 10.2241 2.5 10.5002 2.5H11.5002C11.7764 2.5 12.0002 2.72386 12.0002 3V3.5H10.0002V3Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25528 10.5712L8.46189 13.4644C8.48256 13.7538 8.25333 14 7.96316 14H1.53714C1.24696 14 1.01773 13.7538 1.03841 13.4644L1.24506 10.5712C1.24845 10.5238 1.24845 10.4762 1.24506 10.4288L1.03841 7.53562C1.01773 7.24619 1.24696 7 1.53714 7H3.00024V6.5C3.00024 5.67157 3.67182 5 4.50024 5H5.00024C5.82867 5 6.50024 5.67157 6.50024 6.5V7H7.96316C8.25333 7 8.4826 7.24619 8.46193 7.53562L8.25528 10.4288C8.25189 10.4762 8.25189 10.5238 8.25528 10.5712ZM5.50024 7V6.5C5.50024 6.22386 5.27639 6 5.00024 6H4.50024C4.2241 6 4.00024 6.22386 4.00024 6.5V7H5.50024Z"
        fill={color}
      />
    </svg>
  );
};
